import { Injectable, signal } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class IssueService {
	hasIssueSignal = signal(false);
	showNetworkStatusSignal = signal(false);
	suppressNetworkStatusSignal = signal(false);

	setIssueSignal(hasIssue: boolean) {
		this.hasIssueSignal.set(hasIssue);
	}

	setNetworkSignal(showNetworkStatus: boolean) {
		this.hasIssueSignal.set(showNetworkStatus);
	}

	getIssueSignal(): boolean {
		return this.hasIssueSignal();
	}

	getNetworkStatusSignal(): boolean {
		return this.showNetworkStatusSignal();
	}

	setSuppressNetworkStatusSignal(suppressNetworkStatus: boolean): void {
		this.suppressNetworkStatusSignal.set(suppressNetworkStatus);
	}

	getSuppressNetworkStatusSignal(): boolean {
		return this.suppressNetworkStatusSignal();
	}
}
